<span [ngbTooltip]="tt" container="body">{{ job.statusLabel }}</span>

<ng-template #tt>
    Since {{ job.statusChange | str2Date | date: 'short' }}
    <span class="text-nowrap">({{ job.statusChange | str2Date | amTimeAgo }})</span>
</ng-template>
